// extracted by mini-css-extract-plugin
module.exports = {"textBody":"Link_textBody__S90pv"};